import { render, staticRenderFns } from "./Ice.vue?vue&type=template&id=5685dc8e"
import script from "./Ice.vue?vue&type=script&lang=js"
export * from "./Ice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports